<template>
  <main-layout>
    <v-container>
      <h1>{{ $t('wrs.sync_board') }}</h1>
      <div class="arrow mt-2 pa-2" style="border: 1px solid #eee; border-radius: 5px">
        <v-layout row wrap align-center>
          <v-flex xs6>
            <div>
              {{ $t('wrs.sync_data_detail') }}
            </div>
          </v-flex>
          <v-flex xs6 class="text-xs-right">
            <v-btn color="primary" :loading="isSyncLoading" @click="handleFetchSyncData">
              <v-icon left>cached</v-icon>
              {{ $t('wrs.sync_data') }}
            </v-btn>
            <div class="primary--text pt-1">
              ({{ $t('wrs.latest_sync_data_at') }}:
              <template v-if="latestSync">{{
                latestSync | DateFormat('DD/MM/YYYY HH:mm')
              }}</template>
              <template v-else>-</template>
              )
            </div>
          </v-flex>
        </v-layout>
      </div>
      <v-divider class="py-3"></v-divider>
      <div class="hr"></div>
      <div class="pt-3">
        <h2>{{ $t('wrs.search_coupon_code') }}</h2>

        <div class="default-input mt-1">
          <v-text-field
            id="search"
            v-model="search"
            name="search"
            single-line
            :placeholder="$t('Search')"
            outline
            clearable
            prepend-inner-icon="search"
            hide-details
            @click:clear="
              couponCodes = []
              isShowSearchResult = false
            "
          ></v-text-field>
        </div>
        <div class="text-xs-center mt-1">
          <v-btn outline color="primary" @click="handleOnSearch()">
            {{ $t('Search') }}
          </v-btn>
        </div>
      </div>

      <div v-if="search && isShowSearchResult" class="mt-2">
        <template v-if="couponCodes.length > 0">
          <v-data-table
            hide-actions
            :headers="headers"
            :items="couponCodes"
            :pagination.sync="pagination"
            class="elevation-1 mt-3"
          >
            <template #items="props">
              <tr>
                <td>{{ props.item.coupon_code }}</td>
                <td>{{ props.item.board_name }}</td>
                <td>{{ props.item.car_type || '-' }}</td>
                <td>{{ props.item.status || '-' }}</td>
                <td>{{ props.item.updated_at | DateFormat('DD/MM/YYYY HH:mm') }}</td>
              </tr>
            </template>
          </v-data-table>
          <div v-if="pageLength > 1" class="text-xs-center mt-2">
            <v-pagination
              v-model="pageNumber"
              :total-visible="15"
              :length="pageLength"
              @input="handleChangePage"
            ></v-pagination>
          </div>
        </template>
        <template v-else>
          <div style="text-align: center; border: 1px solid #eee; border-radius: 5px" class="py-3">
            {{ $t('wrs.no_data_found') }}
          </div>
        </template>
      </div>
    </v-container>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import wrsApi from '@/api/wrs'

export default {
  components: {},
  data() {
    return {
      isSyncLoading: false,
      search: '',
      couponCodes: [],
      latestSync: null,
      total: 0,
      headers: [
        { text: 'Coupon Code', value: 'coupon_code', sortable: false },
        { text: 'Board Name', value: 'board_name', sortable: false },
        { text: 'Car Type', value: 'car_type', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Update At', value: 'updated_at', sortable: false }
      ],
      pagination: { rowsPerPage: -1, sortBy: '' },
      pageTemp: 1,
      pageNumber: 1,
      limit: 20,
      offset: 0,
      isShowSearchResult: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.isSyncLoading = true
    this.handleFetchLatestSync()
  },
  methods: {
    async handleFetchSyncData() {
      const vm = this
      try {
        vm.isSyncLoading = true
        const data = {
          page_id: vm.selectedBot.pageid
        }
        const response = await wrsApi.postWrsSyncBoard(data)

        if (response && response.status === 204) {
          vm.$swal.fire({
            title: vm.$t('Successfully'),
            type: 'success'
          })
          vm.handleFetchLatestSync()
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.isSyncLoading = false
      }
    },
    async getCouponCode(params) {
      try {
        if (!params) return

        const response = await wrsApi.getWrsCouponCode(params)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async handleFetchLatestSync() {
      const vm = this
      try {
        if (!vm.selectedBot.pageid) return

        const params = {
          page_id: vm.selectedBot.pageid,
          limit: 1,
          offset: 0
        }

        const response = await vm.getCouponCode(params)

        if (response && response.status === 200) {
          const responseData = response.data.data || []
          vm.latestSync = responseData.length > 0 ? responseData[0].updated_at : ''
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.isSyncLoading = false
      }
    },
    async handleOnSearch() {
      const vm = this
      try {
        if (!vm.selectedBot.pageid || !vm.search) return

        const params = {
          page_id: vm.selectedBot.pageid,
          limit: vm.limit,
          offset: vm.offset,
          coupon_code: vm.search
        }

        const response = await vm.getCouponCode(params)

        if (response && response.status === 200) {
          const responseData = response.data.data || []
          vm.couponCodes = responseData
          vm.total = response.data.total || 0
        }

        vm.isShowSearchResult = true
      } catch (error) {
        console.error(error)
        vm.couponCodes = []
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pageTemp !== val) {
        vm.pageTemp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.handleOnSearch()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Wrs/SyncBoard.vue